import UniversityFloatingView from "./index.vue";
import Vue from "vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";
import { getErrorMessages } from "@/helpers/api-helper";
import { BadRequestError } from "@/api/types";
import { PropType } from "vue";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  props: {
    updateUniversityObject: {
      type: Object as PropType<ContainerProps["updateUniversityObject"]>,
      required: true,
      default: () => ({
        name: "",
        course: "UNSPECIFIED",
        studentId: 0,
        update: false
      })
    }
  },
  data() {
    return {
      messages: []
    };
  },
  computed: {
    isUpdateModal() {
      return this.updateUniversityObject.update;
    },
    currentPlan() {
      return this.$store.state.domains.plan.currentPlan;
    },
    partnerUser() {
      return this.$store.state.domains.user.partnerUser;
    },
    planId() {
      return Number(this.$route.params["planId"]);
    },
    graduateYear() {
      return this.currentPlan ? this.currentPlan.graduate_year : 0;
    },
    universities() {
      return this.$store.state.pages.plan.universities;
    }
  },
  methods: {
    handleUniversityFloatingViewClose() {
      this.$store.commit("pages/plan/updateUniversityView", {
        isVisible: false
      });
    },
    async handleSearchSelectFieldValue(inputValue, radioValue) {
      try {
        await this.$store.dispatch("pages/plan/getUniversityList", {
          graduateYear: this.graduateYear,
          universityName: inputValue,
          universityCourse: radioValue
        });
      } catch (error) {
        if (error instanceof BadRequestError) {
          this.messages = getErrorMessages(error);
        }
        throw error;
      }
    },
    async handleAddUniversity(inputValue, radioValue) {
      if (!this.partnerUser || !this.universities) return;

      const university = this.universities.find(
        university => university.name === inputValue
      );

      if (!university) return;

      this.messages = [];
      try {
        await this.$store.dispatch("domains/plan/createUniversity", {
          partnerId: this.partnerUser.partner.id,
          planId: this.planId,
          university: {
            name: university.name,
            course: radioValue
          }
        });
      } catch (error) {
        if (error instanceof BadRequestError) {
          this.messages = getErrorMessages(error);
        }
        throw error;
      } finally {
        if (!this.messages.length) {
          this.handleUniversityFloatingViewClose();
          this.$emit("close", university);
        }
      }
    },
    async handleUpdateUniversity(inputValue, radioValue, studentId) {
      if (!this.partnerUser) return;

      this.messages = [];
      try {
        await this.$store.dispatch("domains/plan/updateUniversity", {
          partnerId: this.partnerUser.partner.id,
          planId: this.planId,
          studentId: studentId,
          university: {
            name: inputValue,
            course: radioValue
          }
        });
      } catch (error) {
        if (error instanceof BadRequestError) {
          this.messages = getErrorMessages(error);
        }
        throw error;
      } finally {
        if (!this.messages.length) {
          this.handleUniversityFloatingViewClose();
        }
      }
    }
  },
  render(createElement) {
    return createElement(UniversityFloatingView, {
      props: {
        universities: this.universities,
        messages: this.messages,
        updateUniversityObject: this.updateUniversityObject
      },
      on: {
        closeUniversityFloatingView: this.handleUniversityFloatingViewClose,
        searchSelectFieldValue: this.handleSearchSelectFieldValue,
        addUniversity: this.handleAddUniversity,
        updateUniversity: this.handleUpdateUniversity
      }
    });
  }
});
